<template>
  <v-theme-provider dark>
    <base-section
      id="social"
      class="accent text-center"
      space="56"
    >
      <base-icon class="mb-8">
        mdi-math-compass
      </base-icon>

      <base-section-heading
        color="transparent"
        title="Flag FMS 적용 범위"
      >
        건물 FM용역에 필요한 모든 설비와 함께합니다.
      </base-section-heading>

      <v-container>
        <v-row>
          <v-col
            v-for="(feature, i) in features"
            :key="i"
            cols="12"
            sm="6"
            md="4"
            lg="4"
            xl="3"
          >
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
            </base-avatar-card>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionNews',

    data: () => ({
      features: [
        {
          color: 'primary',
          title: '기계',
          icon: 'mdi-wrench',
          html: '열원설비, 공조설비 등 건물 내 모터류 기계설비 관리',
        },
        {
          color: 'primary',
          title: '전기',
          icon: 'mdi-power-plug',
          html: '발전기, 변압기 등 건물내 전기설비 관리',
        },
        {
          color: 'primary',
          title: '소방',
          icon: 'mdi-fire',
          html: '소화용수설비, 소화전 등 건물 내 소방설비 관리',
        },
        {
          color: 'primary',
          title: '환경',
          icon: 'mdi-broom',
          html: '폐수, 중수시설 및 정화조 관리와 환경미화 전반에 대한 관리',
        },
        {
          color: 'primary',
          title: '건설',
          icon: 'mdi-office-building',
          html: '건물 내 배수, 미장, 조적, 창호 등 건물 영선관리',
        },
        {
          color: 'primary',
          title: '순찰',
          icon: 'mdi-taxi',
          html: '건물 내 경비 필요사항 및 순찰 사항 이력관리',
        },
        {
          color: 'primary',
          title: '승강기',
          icon: 'mdi-elevator',
          html: '에스컬레이터 순찰 및 기기 안전 이력관리',
        },
        {
          color: 'primary',
          title: '안전',
          icon: 'mdi-hand-right',
          html: '공사 전/후 안전관리 등록, 시설 및 현장 안전교육 관리',
        },
      ],
    }),

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
